<template>
	<div v-if="!close" :class="{'nav-active':isShowPopper,'mini':navConfigList.length==4}" class="nav-wrapper">
		<i class="el-icon-error" @click="closei()"></i>
		<!-- <el-popover v-model="isShowPopper" :offset="10" :visible-arrow="false" placement="left"
			popper-class="nav-popper" trigger="hover" v-bind="$attrs" width="100" v-on="$listeners"> -->
		<div class="nav-inner">
			<div v-for="(item,index) in navConfigList" :class="{active:activeIndex===index}" class="nav-item" :key="item.id" @click="handleNavItemClick(item,index)">
				<span class="nav-item__name" v-html="item.name"></span>
			</div>
			<div v-if="wenjuan && questionnaireDisplay" class="questionnaire-btn animate__animated animate__tada animate__repeat-3" @click="$openNewWindow('/new/visitor/questionnaire')">
				<div class="questionnaire-text">问卷调研</div>
			</div>
		</div>
		<!-- </el-popover> -->
	</div>
</template>

<script>
import '../less/ncnav.css';
import {getQuestionnaire} from "~/api/CmsApi";
	export default {
		name: "NcNav",
		props: {
			navConfigList: {
				type: Array,
				default: () => []
			},
			wenjuan: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				close:false,
				activeIndex: 0,
				isShowPopper: true,
        questionnaireDisplay: false
			};
		},
		mounted: function() {
			this.$nextTick(function() {
				window.addEventListener('scroll', this.onScroll)
			});

      if (this.wenjuan) {
        getQuestionnaire().then(res => {
          this.questionnaireDisplay = res.code === 0 && res.data && res.data.records.length > 0;
        })
      }
		},
		methods: {
			closei(){
				this.close = true
			},
			onScroll() {
				let scrolled = document.documentElement.scrollTop || document.body.scrollTop // 586、1063分别为第二个和第三个锚点对应的距离
				if (scrolled < this.navConfigList[0].height) {
					this.activeIndex = 0
				} else if (scrolled < this.navConfigList[1].height && scrolled >= this.navConfigList[0].height) {
					this.activeIndex = 1
				} else if (scrolled < this.navConfigList[2].height && scrolled >= this.navConfigList[1].height) {
					this.activeIndex = 2
				} else if (scrolled < this.navConfigList[3].height && scrolled >= this.navConfigList[2].height) {
					this.activeIndex = 3
				} else {
					this.activeIndex = 4
				}
			},
			handleNavItemClick(item, index) {
				this.activeIndex = index;
				this.$emit('side-click', item.id);
				document.getElementById(item.id).scrollIntoView({
					behavior: "smooth",
					block: 'center'
				});
			}
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/template/NcNav.vue